import {BrowserModule, Title} from "@angular/platform-browser";
import {DEFAULT_CURRENCY_CODE, Injector, LOCALE_ID, NgModule} from "@angular/core";
import ptBr from "@angular/common/locales/pt";
import {CurrencyPipe, registerLocaleData} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AppComponent} from "./app.component";
import {AppRoutingModule} from "./app-routing.module";
import {LoginScreenComponent} from "./core/login-screen/login-screen.component";
import {AuthService} from "./services/auth/auth.service";
import {HomeComponent} from "./core/home/home.component";
import {HttpClientModule} from "@angular/common/http";
import {APIService} from "./services/api.service";
import {ConfigService} from "./services/config.service";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {JwtModule} from "@auth0/angular-jwt";
import {environment} from "../environments/environment";
import {NgbDateAdapter, NgbDateParserFormatter, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {CommonModule} from "@angular/common";
import {CoreModule} from "./core/core.module";
import {DateParserFormatter} from "../_types/DateParserFormatter";
import {DateAdapter} from "../_types/DateAdapter";
import { LoadingService } from "./services/loading.service";
import {MenuService} from "./services/menu.service";

registerLocaleData(ptBr);

export function tokenGetter() {
    return localStorage.getItem("token");
}

export let AppInjector: Injector;

@NgModule({
    declarations: [
        AppComponent,
        LoginScreenComponent,
        HomeComponent
    ],
    imports: [
        BrowserModule,
        CoreModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        HttpClientModule,
        CommonModule,
        JwtModule.forRoot({
            config: {
                tokenGetter,
                allowedDomains: environment.appDomains,
                // disallowedRoutes: ["http://example.com/examplebadroute/"],
            },
        }),
        NgbModule
    ],
    providers: [
        AuthService,
        APIService,
        ConfigService,
        APIService,
        LoadingService,
        MenuService,
        {provide: NgbDateParserFormatter, useClass: DateParserFormatter},
        {provide: NgbDateAdapter, useClass: DateAdapter},
        {provide: LOCALE_ID, useValue: "pt-PT" },
        {provide: DEFAULT_CURRENCY_CODE, useValue: "BRL" },
        CurrencyPipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private appTitle: Title, private injector: Injector) {
        this.appTitle.setTitle(environment.appTitle);
        AppInjector = this.injector;
    }
}
